import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PATH_SEGMENTS, route } from '../../config/paths';
import './LandingFooter.css';

const LandingFooter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onLanding = location.pathname === '/';

  const goSection = (hash: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onLanding) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.hash = hash;
      return;
    }
    navigate({ pathname: route(), hash: hash.replace('#', '') });
  };

  return (
    <footer className="landing-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <img src="/vhu-mmt-horizontal.png" alt="Vhearu" className="footer-logo-img" />
          </div>
          <p className="footer-description">
            Evaluate, coach, and act on every conversation — with live voice agents you can try
            today.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Products</h4>
          <ul className="footer-links">
            <li>
              <a href="/#product-autoqa" onClick={goSection('#product-autoqa')}>
                AutoQA
              </a>
            </li>
            <li>
              <a href="/#product-assist" onClick={goSection('#product-assist')}>
                AgentAssist
              </a>
            </li>
            <li>
              <a href="/#product-voice" onClick={goSection('#product-voice')}>
                Voice Agent
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Try it</h4>
          <ul className="footer-links">
            <li>
              <Link to={route(PATH_SEGMENTS.LIVE_DEMO)}>Live demos</Link>
            </li>
            <li>
              <a href="/#live-demos" onClick={goSection('#live-demos')}>
                Featured demos
              </a>
            </li>
            <li>
              <a href="/#features" onClick={goSection('#features')}>
                Capabilities
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Company</h4>
          <ul className="footer-links">
            <li>
              <a href="/#products" onClick={goSection('#products')}>
                About
              </a>
            </li>
            <li>
              <a href="mailto:hello@vhearu.com">Contact</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">© {new Date().getFullYear()} Vhearu. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
